const config = {
  ENV: "test"
};
export default config;
